"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function BackIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { width: "14", height: "12", viewBox: "0 0 14 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { d: "M5.4707 0.814453L0.689453 5.5957L0.302734 6L0.689453 6.4043L5.4707 11.1855L6.2793 10.377L2.46484 6.5625H13.75V5.4375H2.46484L6.2793 1.62305L5.4707 0.814453Z", fill: "black" }) }));
}
exports.default = BackIcon;
